import {
  AfterContentInit,
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";

import { fromEvent, Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { AccountSettingService } from "src/app/Services/account-setting.service";

import { Options } from "@angular-slider/ngx-slider";
import { TranslateService } from "@ngx-translate/core";

import { EmbryoService } from "../../../Services/Embryo.service";
import { HomePageService } from "../../../Services/home-page.service";
import { LoginUsersService } from "../../../Services/login-users.service";
import { ProductsService } from "../../../Services/product.service";
import { MarketingService } from "src/app/Services/marketing.service";

import { MetaService } from "src/app/Services/meta-data.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
@Component({
  selector: "app-ProductsList",
  templateUrl: "./ProductsList.component.html",
  styleUrls: ["./ProductsList.component.scss"],
})
export class ProductsListComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("searchq", { static: true }) searchq!: ElementRef;
  @ViewChild("sidenav", { static: true }) sidenav: any;

  manualRefresh: EventEmitter<void> = new EventEmitter<void>();
  subCategories: any = [];
  type: any;
  pips: boolean = true;
  tooltips: boolean = true;
  category: any;
  pageTitle: string = "";
  subPageTitle: string = "";
  public sidenavOpen: boolean = false;
  public subscribers: any = {};
  public showItems: number = 0;
  isGridView = localStorage.getItem("isGridView")
    ? localStorage.getItem("isGridView")
    : "false";
  showResult: boolean = false;
  page: number = 1;
  nameRouting: any = [];
  attributes: Array<any>;
  fakeArray = new Array(12);
  public filter = {
    q: "",
    search: "",
    brand_ids: <any[]>[],
    sub_categories: <any[]>[],
    sub_categories_slugs: <any[]>[],
    categories: <any[]>[],
    category_id: "",
    category_slug: "",
    price_from: <any>null,
    price_to: <any>null,
    page: 1,
    page_size: localStorage.getItem("page_size")
      ? localStorage.getItem("page_size")
      : "24",
    sort: "",
    attributes_ids: <any[]>[],
    vendor_ids: <any[]>[],
    options_values_ids: <any[]>[],
    group_id: <any[]>[],
    group_slugs: <any[]>[],
    list_ids: <any[]>[],
    promotions: false,
    in_stock: "",
  };
  fitstTime: boolean = true;
  minValue: number = 0;
  maxValue: number = 0;
  minInputValue: number = 0;
  maxInputValue: number = 0;
  options: Options = {
    floor: 0,
    ceil: 100000,
    noSwitching: true,
    rightToLeft: false,
    combineLabels: () => "",
    translate: () => {
      return "";
    },
  };
  total: any;
  all_brand: boolean = true;
  products: any[] = [];
  attributesList: any[] = [];
  categories: any[] = [];
  brands: any[] = [];
  nameGroup: any;
  q: any;
  objectProducts: any;
  totalPage: any;
  loading: boolean = true;
  emptyProducts: boolean = false;
  lang: string = "";
  panelOpenState: boolean = true;
  stocks = [
    { id: "", checked: true, name: "All", name_ar: "الكل" },
    { id: 1, checked: false, name: "In stock", name_ar: "متوفر" },
    { id: 0, checked: false, name: "Out of stock", name_ar: "غير متوفر" },
  ];
  // sorts = [
  //   { name: "product_list.default", value: "" },
  //   { name: "product_list.popularCategories", value: "popular" },
  //   { name: "product_list.Title:A-Z", value: "a-z" },
  //   { name: "product_list.Title:Z-A", value: "z-a" },
  //   { name: "product_list.Price:LowtoHigh", value: "low" },
  //   { name: "product_list.Price:HightoLow", value: "high" },
  //   { name: "product_list.Rate:LowtoHigh", value: "low-rate" },
  //   { name: "product_list.Rate:HightoLow", value: "high-rate" },
  //   { name: "product_list.recent", value: "recent" },
  // ];


  customColors = ["transparent", "squad"];
  originalMax: number = 0;
  acceptPrice: boolean = false;
  fixedBrands: any[] = [];
  routerSubscription: any;
  environmentVariables: any;
  showSubCategory: boolean = false;
  showBrands: boolean = false;
  showOptions: boolean = false;
  areaSubscription: Subscription;
  branchSubscription: Subscription;
  showOffers: boolean = false;
  currentPageView: any = ''
  currentPageViewUrl: any
  sorts :any = []
  constructor(
    public activatedRoute: ActivatedRoute,
    public router: Router,
    private ProductsService: ProductsService,
    public embryoService: EmbryoService,
    public homePageService: HomePageService,
    private auth: LoginUsersService,
    public translate: TranslateService,
    private account: AccountSettingService,
    private confgServ: StaticPagesService,
    private metaService: MetaService,
    private marketingService: MarketingService
  ) {
    this.areaSubscription = this.auth.getAreaDataEmit().subscribe((res) => {
      this.getAllProducts(this.filter);
    });

    this.branchSubscription = this.auth
      .getBranchDataEmit()
      .subscribe((res) => {
        this.getAllProducts(this.filter);
      });
    
    this.attributes = [];
    if (this.router.url.includes("deals")) {
      this.filter.promotions = true;
      this.showOffers = true
    }
    else {
      this.showOffers = false
    }

    this.confgServ.getenvConfig().subscribe((res) => {
      this.environmentVariables = res;
      if (this.environmentVariables?.SEARCH_PAGE_VIEW == "list") {
        this.selectViewProduct("true");
      } else {
        this.selectViewProduct("false");
      }
    });

    this.sorts = [
      { name: "product_list.default", value: "" },
      { name: "product_list.popularCategories", value: "popular" },
      { name: "product_list.Title:A-Z", value: "a-z" },
      { name: "product_list.Title:Z-A", value: "z-a" },
      { name: "product_list.Price:LowtoHigh", value: "low" },
      { name: "product_list.Price:HightoLow", value: "high" },
      // Adding Rate sorting based on a condition
      this.environmentVariables.ENABLE_PRODUCT_RATE ? { name: "product_list.Rate:LowtoHigh", value: "low-rate" } : null,
      this.environmentVariables.ENABLE_PRODUCT_RATE ? { name: "product_list.Rate:HightoLow", value: "high-rate" } : null,
      { name: "product_list.discount:high-discount", value: "high-discount" },
      { name: "product_list.recent", value: "recent" },
    ].filter(sort => sort !== null);

    this.embryoService.emitLang.subscribe((lang: any) => {
      this.lang = lang;
      this.translate.setDefaultLang(lang);

      if (this.lang == "en") {
        this.metaService.updateTag({
          property: "og:title",
          content: `Search - ${this.environmentVariables?.APP_NAME}`,
        });
        this.metaService.setTitle(
          `Search - ${this.environmentVariables?.APP_NAME}`
        );
      }
      else {
        this.metaService.updateTag({
          property: "og:title",
          content: `البحث - ${this.environmentVariables?.APP_NAME_AR}`,
        });
        this.metaService.setTitle(
          `البحث - ${this.environmentVariables?.APP_NAME_AR}`
        );
      }
    });
  }

  ngAfterViewInit(): void {
    this.marketingInitCriteoq();
  }

  marketingInitCriteoq() {
    let profile = JSON.parse(localStorage.getItem('auth_user_crocs')!);
    let vistorId = localStorage.getItem('vistorId');
    let _items = this.products?.map((product) => {
      return {
        id: product.id,
      };
    });

    let q = this.filter.q.replace(/[^\w\s.&-]+/g, '');

    setTimeout(() => {
      this.marketingService.initCriteoq(profile, vistorId, 'viewList', {
        item: _items,
        category: this.filter.category_id,
        keywords: q,
        page_number: this.filter.page
      });
    }, 100);
  }

  ngOnInit() {
    this.fixedBrands = JSON.parse(
      <string>localStorage.getItem("fixedBrands")
    );
    this.lang = localStorage.getItem("lang") || "en";
    this.embryoService.emitLang.subscribe((lang: string) => {
      if (this.lang !== lang) {
        this.lang = lang;
        this.translate.setDefaultLang(this.lang);
        this.getRouting();
        if (this.lang === "ar") {
          this.options.rightToLeft = true;
        } else {
          this.options.rightToLeft = false;
        }
      }
    });

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.getRouting();
      }
    });

    this.homePageService.categoriesDataSub.subscribe((res) => {
      this.categories = [...res];
      if (this.categories && this.categories?.length > 0) {
        this.getRouting();
      }
    });

    this.translate.setDefaultLang(this.lang);
    this.search();
    if (window.innerWidth < 1100) this.sidenavOpen = false;
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
    this.areaSubscription?.unsubscribe();
    this.branchSubscription?.unsubscribe();
  }

  selectViewProduct(value: any) {
    this.isGridView = value;
    localStorage.setItem("isGridView", value);
  }

  sortingFunction(key: any, order = "asc") {
    return (a: any, b: any) => 0;
  }

  changePageItems(size: any) {
    this.filter.page_size = size;
    this.filter.price_from = this.minValue;
    this.filter.price_to = this.maxValue;
    this.filter.page = 1;
    localStorage.setItem("page_size", size);
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { page_size: size, page: 1 },
      queryParamsHandling: "merge",
    });
  }

  changePageItemsSort(sort: any) {
    this.filter.sort = sort;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { sort: sort },
      queryParamsHandling: "merge",
    });
  }

  openSideBar() {
    const body = <HTMLBodyElement>document.body;
    this.sidenavOpen
      ? (this.sidenavOpen = false)
      : (this.sidenavOpen = true);

    if(this.sidenavOpen){
      body.classList.add('overflow-hidden')
    }
    else {
      body.classList.remove('overflow-hidden')
    }
  }

  searchProductStock(stock: any) {
    if (this.environmentVariables.MENU_LINK_TYPE === 'slug') {
      this.router.navigate(["/" + this.lang + "/product"])
      this.filter.in_stock = stock.id;
      this.getAllProducts(this.filter);
    } else {

      this.router.navigate(["/" + this.lang + "/product"], {
        queryParams: {
          category_id: this.filter.category_id,
          in_stock: stock.id,
        },
      });
      this.filter.in_stock = stock.id;
      this.getAllProducts(this.filter);
    }

  }

  searchProductCategory(category: any) {
    if (this.environmentVariables.MENU_LINK_TYPE === 'slug') {
      const currentUrl = this.router.url;
      this.subCategories = category.groups.sort(
        this.sortingFunction("order")
      );
      this.subCategories.forEach((group: any) =>
        group.sub_categories.sort(this.sortingFunction("order"))
      );
      this.nameGroup = category.name;
      this.filter.category_slug = category.slug;
      this.activatedRoute.queryParams.subscribe((params) => {
        let queryParams = <any>{};
        if (params["search"]) {
          queryParams.search = params["search"];
        }
        if (this.acceptPrice == true) {
          queryParams.price_from = this.minValue;
          queryParams.price_to = this.maxValue;
        }
        this.router.navigate([this.lang + '/product/' + category.slug]);
        this.getRouting()
      });
    } else {
      this.subCategories = category.groups.sort(
        this.sortingFunction("order")
      );
      this.subCategories.forEach((group: any) =>
        group.sub_categories.sort(this.sortingFunction("order"))
      );
      this.nameGroup = category.name;
      this.filter.category_id = category.id;
      this.activatedRoute.queryParams.subscribe((params) => {
        let queryParams = <any>{
          category_id: category.id,
          category_name: category.name,
        };
        if (params["search"]) {
          queryParams.search = params["search"];
        }
        if (this.acceptPrice == true) {
          queryParams.price_from = this.minValue;
          queryParams.price_to = this.maxValue;
        }
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: queryParams,
        });
      });
    }
  }

  searchByBrand(data: any) {
    if (data) {
      this.all_brand = false;
      this.filter.page = 1;
      this.page = 1;
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: {
          brand_id: data.id,
          brand_name: data.name,
        },
        queryParamsHandling: "merge",
        skipLocationChange: true,
      });
    }
    else {
      this.all_brand = true;
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: {
          brand_id: "",
        },
        queryParamsHandling: "merge",
        skipLocationChange: true,
      });
    }
  }

  searchProductSubCategory(event: any, subcat: any) {
    this.filter.sub_categories = [];
    this.filter.sub_categories_slugs = [];
    let sub_categories_names: any[] = [];
    let category_name: any;

    if (this.environmentVariables.MENU_LINK_TYPE == 'slug') {
      this.activatedRoute.queryParams.subscribe((params) => {
        if (params['category_id']) {
          let categorySlug = this.categories.find(x => x.id == params['category_id'])
          const filteredSubCategories = categorySlug?.groups
            .flatMap((x: any) => x.sub_categories.map((sub: any) => ({ groupId: x.id, slug: sub.slug })))
            .filter((sub: any) => params['sub_category_id'].includes(sub.slug));

          filteredSubCategories.push(subcat?.slug)
          this.router.navigate([`${this.lang}/product/${categorySlug.slug}/general/${filteredSubCategories.join('--')}`])
        } else {
          category_name = this.categories.filter((element: any) => {
            return element.id == this.filter.category_id;
          })[0]?.name;
          const segments = this.router.url.split('/');

          subcat.checked = event.checked;
          if (!subcat.checked) {
            this.filter.sub_categories_slugs = this.filter.sub_categories_slugs.filter(x => x != subcat.slug);
            this.filter.sub_categories_slugs = [... new Set(this.filter.sub_categories_slugs)]
            this.router.navigateByUrl("/" + this.lang + "/product/" + segments[3] + '/' + (this.filter.group_slugs.length == 1
              ? this.filter.group_slugs[0] : 'general') + '/' + this.filter.sub_categories_slugs.slice(0).join('--').replace(/--$/, ''))
          } else {
            this.subCategories.forEach((group: any) => {
              this.filter.sub_categories_slugs = this.filter.sub_categories_slugs.concat(
                group.sub_categories
                  .filter((subcat: any) => subcat.checked)
                  .map((cat: any) => cat.slug)
              );
            });
          }



          this.subCategories.forEach((group: any) => {
            this.filter.group_slugs = this.filter.group_slugs.concat(
              group.sub_categories
                .filter((subcat: any) => subcat.checked)
                .map((cat: any) => group.slug)
            );
          });

          this.filter.group_slugs = [... new Set(this.filter.group_slugs)]

          this.subCategories.forEach((group: any) => {
            sub_categories_names = sub_categories_names.concat(
              group.sub_categories
                .filter((subcat: any) => subcat.checked)
                .map((cat: any) => cat.name)
            );
          });

          const sub_category_slug = this.filter.sub_categories_slugs;
          this.filter.page = 1;
          this.activatedRoute.queryParams.subscribe((params) => {
            if (sub_category_slug?.length) {
              if (params["in_stock"]) {
                this.router.navigate(["/" + this.lang + "/product"], {
                  queryParams: {
                    category_id: params["category_id"],
                    category_name: category_name,
                    in_stock: params["in_stock"],
                    page: 1,
                  },
                });
              }
              if (segments[3]) {
                this.router.navigate(["/" + this.lang + "/product/" + segments[3] + '/' +
                  (this.filter.group_slugs.length == 1
                    ? this.filter.group_slugs[0] : 'general') + '/' + subcat.slug])

              }


              if (segments[5]?.length > 0) {
                if (subcat?.slug && subcat?.checked) {
                  let test = segments[5]?.split("?");
                  const concatenatedString: string = test[0].concat("--").concat(subcat?.slug).concat("?").concat(test[1]);
                  this.router.navigateByUrl("/" + this.lang + "/product/" + segments[3] + '/' + (this.filter.group_slugs.length == 1
                    ? this.filter.group_slugs[0] : 'general') + '/' + concatenatedString)
                } else {
                  this.router.navigateByUrl("/" + this.lang + "/product/" + segments[3] + '/' + (this.filter.group_slugs.length == 1
                    ? this.filter.group_slugs[0] : 'general') + '/' + this.filter.sub_categories_slugs.slice(0).join('--').replace(/--$/, ''))
                }

                // , {
                //     queryParams: {
                //         category_id: this.filter.category_id,
                //         category_name: category_name,
                //         sub_category_id: sub_category_id,
                //         sub_category_name: sub_categories_names,
                //         page: 1,
                //     },
                //     queryParamsHandling: "merge",
                // });
              }


              if (params["brand_id"]) {
                this.router.navigate(["/" + this.lang + "/product"], {
                  queryParams: {
                    brand_id: params["brand_id"],
                    category_name: category_name,
                    sub_category_id: sub_category_slug,
                    sub_category_name: sub_categories_names,
                    page: 1,
                  },
                  queryParamsHandling: "merge",
                });
              }
              if (params["group_id"]) {
                this.router.navigate(["/" + this.lang + "/product"], {
                  queryParams: {
                    group_id: params["group_id"],
                    category_name: category_name,
                    sub_category_id: sub_category_slug,
                    sub_category_name: sub_categories_names,
                    page: 1,
                  },
                  queryParamsHandling: "merge",
                });
              }
              if (params["search"]) {
                this.router.navigate(["/" + this.lang + "/product"], {
                  queryParams: {
                    category_name: category_name,
                    sub_category_id: sub_category_slug,
                    sub_category_name: sub_categories_names,
                    page: 1,
                  },
                  queryParamsHandling: "merge",
                });
              }
              if (params["list_ids"]) {
                this.router.navigate(["/" + this.lang + "/product"], {
                  // queryParams: {
                  //     category_name: category_name,
                  //     sub_category_id: sub_category_id,
                  //     sub_category_name: sub_categories_names,
                  //     page: 1,
                  // },
                  queryParams: {
                    // category_id: this.filter.category_id,
                    // category_name: category_name,
                    list_ids: params["list_ids"],
                    sub_category_id: sub_category_slug,
                    sub_category_name: sub_categories_names,
                    page: 1,
                  },
                  queryParamsHandling: "merge",
                });
              }
            } else {
              if (params["in_stock"]) {
                this.router.navigate(["/" + this.lang + "/product"], {
                  queryParams: {
                    category_id: this.filter.category_id,
                    category_name: category_name,
                    in_stock: this.filter.in_stock,
                    sub_category_id: null,
                    page: 1,
                  },
                  queryParamsHandling: "merge",
                });
              }
              if (params["category_id"]) {
                this.router.navigate(["/" + this.lang + "/product"], {
                  queryParams: {
                    category_id: this.filter.category_id,
                    category_name: category_name,
                    sub_category_id: null,
                    page: 1,
                  },
                  queryParamsHandling: "merge",
                });
              }
              if (params["brand_id"]) {
                this.router.navigate(["/" + this.lang + "/product"], {
                  queryParams: {
                    brand_id: this.filter.brand_ids,
                    sub_category_id: null,
                    page: 1,
                  },
                  queryParamsHandling: "merge",
                });
                this.all_brand = false;
              } else {
                this.all_brand = true;
              }
              if (params["group_id"]) {
                this.router.navigate(["/" + this.lang + "/product"], {
                  queryParams: {
                    group_id: params["group_id"],
                    sub_category_id: null,
                    page: 1,
                  },
                  queryParamsHandling: "merge",
                });
              }
              if (params["search"]) {
                this.router.navigate(["/" + this.lang + "/product"], {
                  queryParams: {
                    search: params["search"],
                    sub_category_id: null,
                    page: 1,
                  },
                  queryParamsHandling: "merge",
                });
              }
              if (params["list_ids"]) {
                this.router.navigate(["/" + this.lang + "/product"], {
                  queryParams: {
                    list_ids: params["list_ids"],
                    sub_category_id: null,
                    sub_category_name: null,
                    page: 1,
                  },
                  queryParamsHandling: "merge",
                });
              }
            }
          });
        }


      })


    }
    else {
      category_name = this.categories.filter((element: any) => {
        return element.id == this.filter.category_id;
      })[0]?.name;

      subcat.checked = event.checked;
      this.subCategories.forEach((group: any) => {
        this.filter.sub_categories = this.filter.sub_categories.concat(
          group.sub_categories
            .filter((subcat: any) => subcat.checked)
            .map((cat: any) => cat.id)
        );
      });
      this.subCategories.forEach((group: any) => {
        sub_categories_names = sub_categories_names.concat(
          group.sub_categories
            .filter((subcat: any) => subcat.checked)
            .map((cat: any) => cat.name)
        );
      });

      const sub_category_id = this.filter.sub_categories;
      this.filter.page = 1;

      this.activatedRoute.queryParams.subscribe((params) => {
        if (sub_category_id?.length) {
          if (params["in_stock"]) {
            this.router.navigate(["/" + this.lang + "/products"], {
              queryParams: {
                category_id: params["category_id"],
                category_name: category_name,
                in_stock: params["in_stock"],
                page: 1,
              },
            });
          }
          if (params["category_id"]) {
            this.router.navigate(["/" + this.lang + "/products"], {
              queryParams: {
                category_id: params["category_id"],
                category_name: category_name,
                sub_category_id: sub_category_id,
                sub_category_name: sub_categories_names,
                page: 1,
              },
              queryParamsHandling: "merge",
            });
          }
          if (params["sub_category_id"]) {
            this.router.navigate(["/" + this.lang + "/products"], {
              queryParams: {
                category_id: this.filter.category_id,
                category_name: category_name,
                sub_category_id: sub_category_id,
                sub_category_name: sub_categories_names,
                page: 1,
              },
              queryParamsHandling: "merge",
            });
          }
          if (params["brand_id"]) {
            this.router.navigate(["/" + this.lang + "/products"], {
              queryParams: {
                brand_id: params["brand_id"],
                category_name: category_name,
                sub_category_id: sub_category_id,
                sub_category_name: sub_categories_names,
                page: 1,
              },
              queryParamsHandling: "merge",
            });
          }
          if (params["group_id"]) {
            this.router.navigate(["/" + this.lang + "/products"], {
              queryParams: {
                group_id: params["group_id"],
                category_name: category_name,
                sub_category_id: sub_category_id,
                sub_category_name: sub_categories_names,
                page: 1,
              },
              queryParamsHandling: "merge",
            });
          }
          if (params["search"]) {
            this.router.navigate(["/" + this.lang + "/products"], {
              queryParams: {
                category_name: category_name,
                sub_category_id: sub_category_id,
                sub_category_name: sub_categories_names,
                page: 1,
              },
              queryParamsHandling: "merge",
            });
          }
          if (params["list_ids"]) {
            this.router.navigate(["/" + this.lang + "/products"], {
              // queryParams: {
              //     category_name: category_name,
              //     sub_category_id: sub_category_id,
              //     sub_category_name: sub_categories_names,
              //     page: 1,
              // },
              queryParams: {
                // category_id: this.filter.category_id,
                // category_name: category_name,
                list_ids: params["list_ids"],
                sub_category_id: sub_category_id,
                sub_category_name: sub_categories_names,
                page: 1,
              },
              queryParamsHandling: "merge",
            });
          }
        } else {
          if (params["in_stock"]) {
            this.router.navigate(["/" + this.lang + "/products"], {
              queryParams: {
                category_id: this.filter.category_id,
                category_name: category_name,
                in_stock: this.filter.in_stock,
                sub_category_id: null,
                page: 1,
              },
              queryParamsHandling: "merge",
            });
          }
          if (params["category_id"]) {
            this.router.navigate(["/" + this.lang + "/products"], {
              queryParams: {
                category_id: this.filter.category_id,
                category_name: category_name,
                sub_category_id: null,
                page: 1,
              },
              queryParamsHandling: "merge",
            });
          }
          if (params["brand_id"]) {
            this.router.navigate(["/" + this.lang + "/products"], {
              queryParams: {
                brand_id: this.filter.brand_ids,
                sub_category_id: null,
                page: 1,
              },
              queryParamsHandling: "merge",
            });
            this.all_brand = false;
          } else {
            this.all_brand = true;
          }
          if (params["group_id"]) {
            this.router.navigate(["/" + this.lang + "/products"], {
              queryParams: {
                group_id: params["group_id"],
                sub_category_id: null,
                page: 1,
              },
              queryParamsHandling: "merge",
            });
          }
          if (params["search"]) {
            this.router.navigate(["/" + this.lang + "/products"], {
              queryParams: {
                search: params["search"],
                sub_category_id: null,
                page: 1,
              },
              queryParamsHandling: "merge",
            });
          }
          if (params["list_ids"]) {
            this.router.navigate(["/" + this.lang + "/products"], {
              queryParams: {
                list_ids: params["list_ids"],
                sub_category_id: null,
                sub_category_name: null,
                page: 1,
              },
              queryParamsHandling: "merge",
            });
          }
        }
      });
    }
  }

  searchProductByAttributes(event: any, attr: any) {
    attr["checked"] = event.checked;
    this.filter.options_values_ids = [];
    this.attributes.forEach((group) => {
      this.filter.options_values_ids =
        this.filter.options_values_ids.concat(
          group.values
            .filter((attribute: any) => {
              if (attribute) {
                return attribute.checked;
              }
            })
            .map((cat: any) => cat.id)
        );
    });
    this.addParamToRouter(
      "options_values_ids",
      this.filter.options_values_ids
    );
  }

  searchProductByBrand(event: any, attr: any) {
    attr["checked"] = event.checked;
    const brands = this.brands.filter((brand: any) => brand.checked == true);
    this.filter.brand_ids = [];
    this.filter.brand_ids = this.filter.brand_ids.concat(
      brands.map((brand: any) => brand.id)
    );
    this.filter.brand_ids.length > 0
      ? (this.fixedBrands = this.brands)
      : (this.fixedBrands = []);

    if(this.fixedBrands?.length){
      localStorage.setItem("fixedBrands", JSON.stringify(this.fixedBrands));
    }
    this.addParamToRouter("brand_id", this.filter.brand_ids);
  }

  addParamToRouter(paramName: any, paramValue: any) {
    const urlParameters = Object.assign(
      {},
      this.activatedRoute.snapshot.queryParams
    );

    urlParameters[paramName] = paramValue;
    urlParameters["page"] = 1;
    this.router.navigate([], {
      queryParams: urlParameters,
      relativeTo: this.activatedRoute,
      replaceUrl: true,
      queryParamsHandling: "merge",
    });
    return urlParameters;
  }

  reMapAttributesFromRoute(param: any) {
    if (this.attributes?.length && param?.length) {
      this.attributes?.forEach((group) => {
        group.values?.forEach((attr: any) => {
          if (attr) {
            param?.forEach((value: any) => {
              if (attr.id === Number(value)) {
                attr.checked = true;
              }
            });
          }
        });
      });
    }
  }

  getRouting() {
    this.categories = this.categories;
    this.nameRouting = [];
    this.filter.brand_ids = [];
    this.activatedRoute.queryParams.subscribe((params) => {
      if (!params["category_id"]) {
 
        if (params["q"]) {
          this.filter.q = params["q"];
          this.q = params["q"];
        }
        if (params["sub_category_id"]) {
          this.filter.sub_categories.push(params["sub_category_id"]);
         }

        if (params["search"]) {

          const script = document.createElement('script');
          //  script.type = 'text/javascript';
          script.type = 'application/ld+json';
          script.text = `{
                            "@context": "https://schema.org/",
                            "@type": "WebSite",
                            "name":   "${this.environmentVariables.APP_NAME}",
                            "alternateName":"${this.environmentVariables.APP_NAME}",
                            "url": "${this.environmentVariables.WEBSITE_URL}",
                            "potentialAction": {
                            "@type": "SearchAction",
                            "target": "${this.environmentVariables.WEBSITE_URL + this.router.url}",
                            "query-input": "required name=search_term_string"
                            }	
                        }
              `

          document.body.appendChild(script);

          this.filter.q = params["search"];
          this.q = params["search"];
          this.filter.search = params["search"];
          this.searchq.nativeElement.value = params["search"];
        } else {
          this.searchq.nativeElement.value = "";
          this.filter.q = "";
          this.filter.sub_categories_slugs = [];
          this.subCategories = [];
          this.subCategories.length = 0;
        }

        if (params["promotions"]) {
          this.filter.promotions = Boolean(params["promotions"]);
          this.marketingService.fbTracking("track", "OffersBtn", {
            tag_name: params["promotions"],
          });
        }

        if (params["price_from"]) {
          this.filter.price_from = +params["price_from"];
          this.acceptPrice = true;
        }

        if (params["price_to"]) {
          this.filter.price_to = +params["price_to"];
          this.acceptPrice = true;
        }

        if (params["group_id"]) {
           this.filter.group_id.push(params["group_id"]); 
        }

        if (params["in_stock"]) {
          this.subCategories = [];
          this.subCategories.length = 0;
          this.filter.sub_categories_slugs = [];
          this.filter.in_stock = params["in_stock"];
          this.stocks.forEach((element) => {
            if (element.id == params["in_stock"]) {
              element.checked = true;
            } else {
              element.checked = false;
            }
          });
        }

        const segments = this.router.url.split('/');

        if (segments[3]?.length > 0) {
          setTimeout(() => {
            if (this.lang == 'en') {
              this.metaService.setTitle(
                ` ${segments[3]} |  ${this.environmentVariables?.META_TITLE_EN ? this.environmentVariables?.META_TITLE_EN : this.environmentVariables?.APP_NAME} `
              );
              document.getElementById('MetaDescription')?.setAttribute('content',
                `${segments[3]} | ${this.environmentVariables?.metaDescriptionEn ? this.environmentVariables?.metaDescriptionEn :
                  `Shop for it at ${this.environmentVariables?.APP_NAME}.Shop Quality with direct Delivery or Pickup. It's now easier than ever to buy it online from ${this.environmentVariables?.APP_NAME}`}`
              )
            } else {
              this.metaService.setTitle(
                ` ${segments[3]} |  ${this.environmentVariables?.META_TITLE_AR ? this.environmentVariables?.META_TITLE_AR : this.environmentVariables?.APP_NAME} `
              );
              document.getElementById('MetaDescription')?.setAttribute('content',
                `${segments[3]} | ${this.environmentVariables?.metaDescriptionAr ? this.environmentVariables?.metaDescriptionAr :
                  `عِدْ إلى متجرنا على الإنترنت${this.environmentVariables?.APP_NAME}.وتسوّق بجودة عالية مع التوصيل المباشر أو الاستلام. أصبح الآن أسهل من أي وقتٍ مضى شراء ما تحتاجه عبر الإنترنت من${this.environmentVariables?.APP_NAME}`}`
              )
            }
          }, 1000);

          this.subCategories = [];
          JSON.stringify(params["sub_category_id"]);
          this.subCategories.length = 0;
          // this.filter.sub_categories_slugs = [];
          this.filter.category_slug = segments[3]?.split("?")[0];
          this.categories.forEach((element: any) => {
            if (element?.slug == segments[3]) {
              element.checked = true;
              this.nameGroup = element.name;
              this.nameRouting.push(element);

              this.subCategories = [...element.groups];
              this.subCategories.forEach((group: any) => {
                group.sub_categories.forEach((sub: any) => {
                  sub.checked = false;
                });
              });
            } else {
              element.checked = false;
            }
          });
        } else {
          this.categories.forEach((element: any) => {
            element.checked = false;
          });
        }

        if (this.filter.group_slugs[0] || segments[4]?.length > 0) {



          setTimeout(() => {
            if (this.lang == 'en') {
              this.metaService.setTitle(
                ` ${this.filter.group_slugs[0]} |  ${this.environmentVariables?.META_TITLE_EN ? this.environmentVariables?.META_TITLE_EN : this.environmentVariables?.APP_NAME} `
              );
              document.getElementById('MetaDescription')?.setAttribute('content',
                `${this.filter.group_slugs[0]} | ${this.environmentVariables?.metaDescriptionEn ? this.environmentVariables?.metaDescriptionEn :
                  `Shop for it at ${this.environmentVariables?.APP_NAME}.Shop Quality with direct Delivery or Pickup. It's now easier than ever to buy it online from ${this.environmentVariables?.APP_NAME}`}`
              )
            } else {
              this.metaService.setTitle(
                ` ${this.filter.group_slugs[0]} |  ${this.environmentVariables?.META_TITLE_AR ? this.environmentVariables?.META_TITLE_AR : this.environmentVariables?.APP_NAME} `
              );
              document.getElementById('MetaDescription')?.setAttribute('content',
                `${this.filter.group_slugs[0]} | ${this.environmentVariables?.metaDescriptionAr ? this.environmentVariables?.metaDescriptionAr :
                  `عِدْ إلى متجرنا على الإنترنت${this.environmentVariables?.APP_NAME}.وتسوّق بجودة عالية مع التوصيل المباشر أو الاستلام. أصبح الآن أسهل من أي وقتٍ مضى شراء ما تحتاجه عبر الإنترنت من${this.environmentVariables?.APP_NAME}`}`
              )
            }
          }, 1000);

          this.filter.group_slugs = segments[4] != 'general' ? Array(segments[4]?.split("?")[0]) : []
          if (segments[5]?.length == 0) {
            this.subCategories = [];
            this.subCategories.length = 0;
            this.filter.sub_categories_slugs = [];
            this.filter.category_slug = "";
            this.categories.forEach((element: any) => {
              element.checked = false;
              element.groups.forEach((group: any) => {
                group.sub_categories;
                if (group.slug == segments[4]) {
                  element.checked = true;
                  if (segments[3]?.length == 0) {
                    this.nameRouting.push(element);
                  }
                  this.nameRouting.push(group);

                  this.filter.category_slug = element.slug;
                  this.nameGroup = element.name;
                  this.subCategories = element.groups;
                  group.sub_categories.forEach(
                    (sub_category: any) => {
                      if (sub_category) {
                        this.filter.sub_categories_slugs = [];
                        if(segments[5]){
                          let sub_categories_slugs = segments[5].includes("?")
                            ? segments[5].split("?")[0].split("--")
                            : segments[5].split("--");
                          if(sub_categories_slugs[0]){
                            this.filter.sub_categories_slugs.push(
                              ...new Set(
                                sub_categories_slugs[0]
                                  ? sub_categories_slugs
                                  : []
                              )
                            );
                          }
                        }
                      }
                    }
                  );
                }
              });
            });
          } else {
            this.categories.forEach((element: any) => {
              element.groups.forEach((group: any) => {
                if (group?.slug == segments[4]) {
                  // this.nameRouting.push(element);
                  this.nameRouting.push(group);
                }
              });
            });
          }
        }

        if (segments[5]) {
          this.showSubCategory = true;
          // this.currentPageViewUrl = 

          if (!params["search"]) {
            if (segments[3]?.length == 0) {
              this.subCategories = [];
              this.subCategories.length = 0;
              this.filter.sub_categories_slugs = [];
              this.filter.category_slug = "";
            }
            // const sub_category_ids = JSON.parse(
            //     JSON.stringify(params["sub_category_id"])
            // );

            //will be string and | i split and loop 
            let subs = segments[5]?.split('--');

            setTimeout(() => {
              let sub = segments[5].split('?')
              if (this.lang == 'en') {
                this.metaService.setTitle(
                  ` ${sub[0]} |  ${this.environmentVariables?.META_TITLE_EN ? this.environmentVariables?.META_TITLE_EN : this.environmentVariables?.APP_NAME} `
                );
                document.getElementById('MetaDescription')?.setAttribute('content',
                  `${sub[0]} | ${this.environmentVariables?.metaDescriptionEn ? this.environmentVariables?.metaDescriptionEn :
                    `Shop for it at ${this.environmentVariables?.APP_NAME}.Shop Quality with direct Delivery or Pickup. It's now easier than ever to buy it online from ${this.environmentVariables?.APP_NAME}`}`
                )
              } else {
                this.metaService.setTitle(
                  ` ${sub[0]} |  ${this.environmentVariables?.META_TITLE_AR ? this.environmentVariables?.META_TITLE_AR : this.environmentVariables?.APP_NAME} `
                );
                document.getElementById('MetaDescription')?.setAttribute('content',
                  `${sub[0]} | ${this.environmentVariables?.metaDescriptionAr ? this.environmentVariables?.metaDescriptionAr :
                    `عِدْ إلى متجرنا على الإنترنت${this.environmentVariables?.APP_NAME}.وتسوّق بجودة عالية مع التوصيل المباشر أو الاستلام. أصبح الآن أسهل من أي وقتٍ مضى شراء ما تحتاجه عبر الإنترنت من${this.environmentVariables?.APP_NAME}`}`
                )
              }
            }, 1000);


            if (subs) {
              if (subs?.length > 1) {
                subs.forEach((sub_category_slug) => {
                  this.categories.forEach((element: any) => {
                    element.checked = false;
                    element.groups.forEach((group: any) => {
                      group.sub_categories;
                      group.sub_categories.forEach(
                        (sub_category: any) => {
                          if (
                            sub_category.slug ==
                            sub_category_slug
                          ) {
                             this.filter.group_slugs = segments[4] != 'general' ? Array(segments[4]) : []
                            element.checked = true;
                            sub_category.checked = true;
                            this.subCategories =
                              element.groups;

                            if (
                              segments[3]?.length == 0
                            ) {
                              this.subCategories =
                                element.groups;
                              this.nameGroup =
                                element.name;
                              this.nameRouting.push(
                                element
                              );
                            }
                            this.filter.sub_categories_slugs = []
                            this.filter.sub_categories_slugs.push(
                              ...new Set(
                                segments[5].includes("?")
                                  ? segments[5].split("?")[0].split("--")
                                  : segments[5].split("--")
                              )
                            );
                          }
                        }
                      );
                    });
                  });
                });
              } else {
                this.categories.forEach((element: any) => {
                  element.checked = false;
                  element.groups.forEach((group: any) => {
                    group.sub_categories;
                    group.sub_categories.forEach(
                      (sub_category: any) => {
                        if (
                          sub_category.slug ==
                          segments[5]
                        ) {
                          this.filter.category_slug =
                            element.slug;
                          sub_category.checked = true;
                          element.checked = true;
                          this.subCategories =
                            element.groups;

                          if (segments[3]?.length == 0) {
                            this.subCategories =
                              element.groups;
                            this.nameGroup =
                              element.name;
                          }

                          this.nameRouting.push(
                            sub_category
                          );
                          this.filter.sub_categories_slugs =
                            [
                              // segments[5]
                              ...new Set(
                                segments[5].includes("?")
                                  ? segments[5].split("?")[0].split("--")
                                  : segments[5].split("--")
                              )
                            ];
                        } else {
                          sub_category.checked = false;
                        }
                      }
                    );
                  });
                });
              }
            } else {
              this.categories.forEach((element: any) => {
                element.checked = false;
                element.groups.forEach((group: any) => {
                  group.sub_categories;
                  group.sub_categories.forEach(
                    (sub_category: any) => {
                      if (
                        sub_category.slug == segments[5]
                      ) {
                        this.filter.category_slug =
                          element.slug;
                        sub_category.checked = true;
                        element.checked = true;
                        this.subCategories = element.groups;

                        if (segments[3]?.length == 0) {
                          this.subCategories =
                            element.groups;
                          this.nameGroup = element.name;
                        }
                        this.nameRouting.push(sub_category);
                        this.filter.sub_categories_slugs = []
                        this.filter.sub_categories_slugs.push(
                          ...new Set(
                            segments[5].includes("?")
                              ? segments[5].split("?")[0].split("--")
                              : segments[5].split("--")
                          )
                        );
                      } else {
                        sub_category.checked = false;
                      }
                    }
                  );
                });
              });
            }
          } else {
            // const sub_category_ids = params["sub_category_id"];
            if (Array.isArray(segments[5])) {
              segments[5]?.length > 1
                ? segments[5].forEach(
                  (sub_category_slug) =>
                    this.filter.sub_categories_slugs.push(
                      segments[5].includes("?") ? segments[5].split("?")[0].split("--") : segments[5].split("--")
                    )
                )
                :
                this.filter.sub_categories_slugs = []
              this.filter.sub_categories_slugs.push(
                ...new Set(
                  segments[5].includes("?")
                    ? segments[5].split("?")[0].split("--")
                    : segments[5].split("--")
                )
              );

              //when error in run i fixed it 
              this.subCategories.forEach((group: any) => {
                group.sub_categories.forEach((sub: any) => {
                  segments[5].split('--').includes(`${sub.slug}`)
                    ? (sub.checked = true)
                    : (sub.checked = false);
                });
              });
            } else {
              this.filter.sub_categories_slugs = [
                // segments[5],
                ...new Set(
                  segments[5].includes("?")
                    ? segments[5].split("?")[0].split("--")
                    : segments[5].split("--")
                )
              ];
              //when error in run i fixed it 
              this.subCategories.forEach((group: any) => {
                group.sub_categories.forEach((sub: any) => {
                  segments[5].split('--').includes(`${sub.slug}`)
                    ? (sub.checked = true)
                    : (sub.checked = false);
                });
              });
            }
          }
        }

        if (params["brand_id"]) {
          this.showBrands = true;
          var brandDumb: string | any[];
          Array.isArray(params["brand_id"])
            ? (brandDumb = this.filter.brand_ids = params["brand_id"])
            : (brandDumb = this.filter.brand_ids =
              [params["brand_id"]]);
          this.brands = this.fixedBrands;
          this.brands?.forEach((brand: any) => {
            brandDumb.includes(brand.id)
              ? (brand.checked = true)
              : (brand.checked = false);
          });
        } else {
          this.filter.brand_ids = [];
          this.brands.forEach((brand: any) => (brand.checked = false));
        }

        if (params["list_ids"]) this.filter.list_ids = [params["list_ids"]];

        if (params["page"]) {
          this.filter.page = params["page"];
          this.page = params["page"];
        }
        if (params["options_values_ids"]) {
          this.showOptions = true;
          const data = params["options_values_ids"];
          typeof data === "string"
            ? (this.filter.options_values_ids = [data])
            : (this.filter.options_values_ids = data);
        }

        if (params["sort"]) {
          this.filter.sort = params["sort"];
        }
        if (params["page_size"]) {
          this.filter.page_size = params["page_size"];
        }

        // setTimeout(() => {
        this.getAllProducts(this.filter);
        // }, 3000);
        this.getAllProducts(this.filter, 'enable_search_side_filters=1');


      } else {
         this.activatedRoute.queryParams.subscribe((params) => {
          if (params["q"]) {
            this.filter.q = params["q"];
            this.q = params["q"];
          }

          if (params["search"]) {
            this.filter.q = params["search"];
            this.q = params["search"];
            this.filter.search = params["search"];
            this.searchq.nativeElement.value = params["search"];
          } else {
            this.searchq.nativeElement.value = "";
            this.filter.q = "";
            this.filter.sub_categories = [];
            this.subCategories = [];
            this.subCategories.length = 0;
          }

          if (params["promotions"]) {
            this.filter.promotions = Boolean(params["promotions"]);
            this.marketingService.fbTracking("track", "OffersBtn", {
              tag_name: params["promotions"],
            });
          }

          if (params["price_from"]) {
            this.filter.price_from = +params["price_from"];
            this.acceptPrice = true;
          }

          if (params["price_to"]) {
            this.filter.price_to = +params["price_to"];
            this.acceptPrice = true;
          }

          if (params["in_stock"]) {
            this.subCategories = [];
            this.subCategories.length = 0;
            this.filter.sub_categories = [];
            this.filter.in_stock = params["in_stock"];
            this.stocks.forEach((element) => {
              if (element.id == params["in_stock"]) {
                element.checked = true;
              } else {
                element.checked = false;
              }
            });
          }

          if (params["category_id"]) {
            this.subCategories = [];
            JSON.stringify(params["sub_category_id"]);
            this.subCategories.length = 0;
            this.filter.sub_categories = [];
            this.filter.category_id = params["category_id"];
            this.categories.forEach((element: any) => {
              if (element.id == params["category_id"]) {
                element.checked = true;
                this.nameGroup = element.name;
                this.nameRouting.push(element);
                this.subCategories = [...element.groups];
                this.subCategories.forEach((group: any) => {
                  group.sub_categories.forEach((sub: any) => {
                    sub.checked = false;
                  });
                });
              } else {
                element.checked = false;
              }
            });
          } else {
            this.categories.forEach((element: any) => {
              element.checked = false;
            });
          }

          if (params["group_id"]) {
            // this.currentPageViewUrl = `v2/categories/${params["group_id"]}/subcategories`
            if (!params["sub_category_id"]) {
              this.subCategories = [];
              this.subCategories.length = 0;
              this.filter.sub_categories = [];
              // this.filter.category_id = "";
              this.categories.forEach((element: any) => {
                element.checked = false;
                element.groups.forEach((group: any) => {
                  group.sub_categories;
                   if (group.id == params["group_id"]) {
                    element.checked = true;
                    if (!params["category_id"]) {
                      this.nameRouting.push(element);
                    }
                    this.nameRouting.push(group);

                    this.filter.category_id = element.id;
                    this.nameGroup = element.name;
                    this.subCategories = element.groups;
                    group.sub_categories.forEach(
                      (sub_category: any) => {
                        if (sub_category) {
                          this.filter.sub_categories.push(
                            sub_category.id
                          );
                        }
                      }
                    );
                  }
                });
              });
            } else {
              this.categories.forEach((element: any) => {
                element.groups.forEach((group: any) => {
                  if (group.id == params["group_id"]) {
                    this.nameRouting.push(element);
                    this.nameRouting.push(group);
                  }
                });
              });
            }
          }

          if (params["sub_category_id"]) {
            this.showSubCategory = true;
            // this.currentPageViewUrl = 

            if (!params["search"]) {
              if (!params["category_id"]) {
                this.subCategories = [];
                this.subCategories.length = 0;
                this.filter.sub_categories = [];
                this.filter.sub_categories_slugs = [];
                this.filter.category_id = "";
                this.filter.category_slug = "";
              }
              const sub_category_ids = JSON.parse(
                JSON.stringify(params["sub_category_id"])
              );
              if (Array.isArray(sub_category_ids)) {
                if (sub_category_ids?.length > 1) {
                  sub_category_ids.forEach((sub_category_id) => {
                    this.categories.forEach((element: any) => {
                      element.checked = false;
                      element.groups.forEach((group: any) => {
                        group.sub_categories;
                        group.sub_categories.forEach(
                          (sub_category: any) => {
                            if (
                              sub_category.id ==
                              sub_category_id
                            ) {
                              this.filter.category_id =
                                element.id;
                              element.checked = true;
                              sub_category.checked = true;
                              this.subCategories =
                                element.groups;

                              if (
                                !params["category_id"]
                              ) {
                                this.subCategories =
                                  element.groups;
                                this.nameGroup =
                                  element.name;
                                this.nameRouting.push(
                                  element
                                );
                              }

                              this.filter.sub_categories.push(
                                sub_category_id
                              );
                            }
                          }
                        );
                      });
                    });
                  });
                } else {
                  this.categories.forEach((element: any) => {
                    element.checked = false;
                    element.groups.forEach((group: any) => {
                      group.sub_categories;
                      group.sub_categories.forEach(
                        (sub_category: any) => {
                          if (
                            sub_category.id ==
                            sub_category_ids
                          ) {
                            this.filter.category_id =
                              element.id;
                            sub_category.checked = true;
                            element.checked = true;
                            this.subCategories =
                              element.groups;

                            if (!params["category_id"]) {
                              this.subCategories =
                                element.groups;
                              this.nameGroup =
                                element.name;
                            }

                            this.nameRouting.push(
                              sub_category
                            );
                            this.filter.sub_categories =
                              sub_category_ids;
                          } else {
                            sub_category.checked = false;
                          }
                        }
                      );
                    });
                  });
                }
              } else {
                this.categories.forEach((element: any) => {
                  element.checked = false;
                  element.groups.forEach((group: any) => {
                    group.sub_categories;
                    group.sub_categories.forEach(
                      (sub_category: any) => {
                        if (
                          sub_category.id == sub_category_ids
                        ) {
                          this.filter.category_id =
                            element.id;
                          sub_category.checked = true;
                          element.checked = true;
                          this.subCategories = element.groups;

                          if (!params["category_id"]) {
                            this.subCategories =
                              element.groups;
                            this.nameGroup = element.name;
                          }
                          this.nameRouting.push(sub_category);

                          this.filter.sub_categories.push(
                            sub_category_ids
                          );
                        } else {
                          sub_category.checked = false;
                        }
                      }
                    );
                  });
                });
              }
            } else {
              const sub_category_ids = params["sub_category_id"];
              if (Array.isArray(params["sub_category_id"])) {
                params["sub_category_id"]?.length > 1
                  ? params["sub_category_id"].forEach(
                    (sub_category_id) =>
                      this.filter.sub_categories.push(
                        sub_category_id
                      )
                  )
                  : (this.filter.sub_categories = [
                    params["sub_category_id"],
                  ]);

                this.subCategories.forEach((group: any) => {
                  group.sub_categories.forEach((sub: any) => {
                    params["sub_category_id"].includes(`${sub.id}`)
                      ? (sub.checked = true)
                      : (sub.checked = false);
                  });
                });
              } else {
                this.filter.sub_categories = [
                  params["sub_category_id"],
                ];
                this.subCategories.forEach((group: any) => {
                  group.sub_categories.forEach((sub: any) => {
                    params["sub_category_id"].includes(`${sub.id}`)
                      ? (sub.checked = true)
                      : (sub.checked = false);
                  });
                });
              }
            }
          }

          if (params["brand_id"]) {
            this.showBrands = true;
            var brandDumb: string | any[];
            Array.isArray(params["brand_id"])
              ? (brandDumb = this.filter.brand_ids = params["brand_id"])
              : (brandDumb = this.filter.brand_ids =
                [params["brand_id"]]);
            this.brands = this.fixedBrands;
            this.brands?.forEach((brand: any) => {
              brandDumb.includes(brand.id)
                ? (brand.checked = true)
                : (brand.checked = false);
            });
          } else {
            this.filter.brand_ids = [];
            this.brands.forEach((brand: any) => (brand.checked = false));
          }

          if (params["list_ids"]) this.filter.list_ids = [params["list_ids"]];
          if (params["vendor_ids"]) this.filter.vendor_ids = [params["vendor_ids"]];

          if (params["page"]) {
            this.filter.page = params["page"];
            this.page = params["page"];
          }
          if (params["options_values_ids"]) {
            this.showOptions = true;
            const data = params["options_values_ids"];
            typeof data === "string"
              ? (this.filter.options_values_ids = [data])
              : (this.filter.options_values_ids = data);
          }

          if (params["sort"]) {
            this.filter.sort = params["sort"];
          }
          if (params["page_size"]) {
            this.filter.page_size = params["page_size"];
          }

          // setTimeout(() => {
          this.getAllProducts(this.filter);
          // }, 3000);
          this.getAllProducts(this.filter, 'enable_search_side_filters=1');

        });
      }


    });
  }

  getAllProducts(filter: any, enableSearchSideFilters: any = '') {
    this.showResult = false;
    this.marketingService.fbTracking("track", "Search", {
      search_string: this.filter.search,
    });
    this.marketingService.snapTracking("track", "SEARCH", {
      search_string: this.filter.search,
    });
    if(this.environmentVariables?.tiktokPixelId){
      this.marketingService.ttqTracking('track', 'ViewContent',{
        content_name: `${this.filter.search}`,
        content_category: `${this.filter.category_id}`,
        content_type: 'search',
      })
    }

    if(this.environmentVariables?.GOOGLE_CONVERSION_ID && this.environmentVariables?.GOOGLE_ANALYTICS_ID){
      this.marketingService.GA4Seach(this.filter.search);
    }
    
    let segments = this.router.url.split('/');
    this.filter.category_slug == 'deals' ? this.filter.category_slug = segments[4] : this.filter.category_slug

    this.filter.promotions == true ? this.filter.group_slugs = [] : "";
    if(segments[5]){
      let sub_categories_slugs = segments[5].includes("?")
        ? segments[5].split("?")[0].split("--")
        : segments[5].split("--");
      if(sub_categories_slugs[0]){
        this.filter.sub_categories_slugs.push(
          ...new Set(
            sub_categories_slugs[0]
              ? sub_categories_slugs
              : []
          )
        );
      }
    }





    this.filter.category_slug = this.filter?.category_slug?.split('?')[0]
    this.ProductsService.getProductsSearch(this.filter, enableSearchSideFilters).subscribe(
      (response: any) => {

        this.loading = false;

        this.objectProducts = response?.data;
        this.totalPage = this.objectProducts?.total_products;
        if (!enableSearchSideFilters) {
          this.products = this.objectProducts?.products;
          this.cretaeProductSchema(this.products)
        }

        this.objectProducts = response?.data;
        this.totalPage = this.objectProducts?.total_products;
        if (!enableSearchSideFilters) {
          this.products = this.objectProducts?.products;
          this.cretaeProductSchema(this.products)
        }

        this.total = this.objectProducts?.total_products;
        if (enableSearchSideFilters) {
          this.attributes = this.objectProducts?.products_options;
        }
        let arr: {
          item_name: any;
          item_id: any;
          price: any;
          item_brand: any;
          item_category: any;
          item_category2: any;
          item_list_name: any;
          item_list_id: any;
          index: number;
        }[] = [];
        this.products?.forEach((product: any, index) => {
          let obj = {
            item_name: product.name,
            item_id: product.id,
            price: product.discount_price
              ? product.discount_price
              : product.price,
            item_brand:
              product.details && product.details.brand
                ? product.details.brand.name
                : "",
            item_category: product.category
              ? product.category.name
              : "-",
            item_category2: product.category
              ? product.category.sub_categories
                ? product.category.sub_categories[0].name
                : "-"
              : "-",
            item_list_name: product.actegory
              ? product.actegory.id
              : "",
            item_list_id: product.actegory
              ? product.actegory.name
              : "",
            index: index + 1,
          };
          arr.push(obj);
        });
        let result = {
          event: "search",
          ecommerce: {
            items: arr,
            search_term: this.filter.search,
            extras: this.account.googleAnalaticsUserData,
          },
        };

        this.activatedRoute.queryParams.subscribe((params: any) => {
          if (params["brand_id"]) {
            var brandDumb: string | any[];
            Array.isArray(params["brand_id"])
              ? (brandDumb = this.filter.brand_ids =
                params["brand_id"])
              : (brandDumb = this.filter.brand_ids =
                [params["brand_id"]]);
            this.brands = this.fixedBrands?.length ? this.fixedBrands : response?.data?.brands;
            this.brands?.forEach((brand) => {
              brandDumb.includes(`${brand.id}`)
                ? (brand.checked = true)
                : (brand.checked = false);
            });
          } else {
            this.filter.brand_ids = [];
            if (enableSearchSideFilters) {
              this.brands = response?.data?.brands;

              if(this.brands?.length || this.filter.brand_ids?.length){
                localStorage.setItem("fixedBrands", JSON.stringify(this.brands));
              }
            }
          }

          if (params["in_stock"]) {
            this.filter.in_stock = params["in_stock"];
          }

          if (params["price_from"])
            this.filter.price_from = params["price_from"];

          if (params["price_to"])
            this.filter.price_to = params["price_to"];

          if (
            params["search"] &&
            params["category_id"] &&
            !params["sub_category_id"]
          ) {
            this.subCategories = [...response.data.sub_categories];
          }

          if (params["list_ids"]) {
            this.subCategories = [...response.data.sub_categories];
            if (params["sub_category_id"]) {
              this.subCategories.forEach((element: any) => {
                element.checked = false;

                element.sub_categories.forEach((sub: any) => {
                  if (sub.id == params["sub_category_id"]) {
                    element.checked = true;
                    sub.checked = true;
                  }
                });
              });
            }

            let sectionsList = JSON.parse(
              <any>localStorage.getItem("sections")
            );
            let list = sectionsList.find(
              (item: any) => item.list_id == params["list_ids"]
            );
            this.nameRouting.push(list);
          }
        });
        this.activatedRoute.queryParamMap.subscribe((params) => {
          const param = params.getAll("options_values_ids");
          this.reMapAttributesFromRoute(param);
        });

        if (this.products?.length == 0) {
          this.emptyProducts = true;
        } else {
          this.emptyProducts = false;
        }

        this.maxValue = response?.data?.max_price;
        this.minValue = response?.data?.min_price;
        this.maxInputValue = response?.data?.max_price;
        this.minInputValue = response?.data?.min_price;
        this.fitstTime = false;
        this.changeOptions(
          response?.data?.min_price,
          response?.data?.max_price
        );
        this.showResult = true;

        this.manualRefresh.emit();
        setTimeout(() => {
          document.body.style.overflow = "auto";
        }, 1000);
      }
    );
  }

  checkOptionFound(values: any): any {
    const found = values.findIndex((item: any) => item.checked == true);

    if (found != -1 && values[found]?.checked) return true;
    return;
  }

  search() {
    const searchKeyword = fromEvent(this.searchq.nativeElement, "keyup");
    searchKeyword.pipe(debounceTime(1200)).subscribe((q: any) => {
      this.filter.q = (<string>q.target.value);
    
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { search: this.filter.q },
        queryParamsHandling: "merge",
      });
    });
  }

  public onPageChanged(event: any) {
    this.page = event;
    this.filter.page = event;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { page: event },
      queryParamsHandling: "merge",
    });

  }

  public addToCart(value: any) {
    this.embryoService.addToCartGuest(value);
  }

  public addToWishList(value: any) {
    this.embryoService.addToWishlist(value);
  }

  public transformHits(hits: any) {
    hits.forEach((hit: any) => {
      hit.stars = [];
      for (let i = 1; i <= 5; i) {
        hit.stars.push(i <= hit.rating);
        i += 1;
      }
    });
    return hits;
  }

  changeOptions(floor: any, ceil: any) {
    const newOptions: Options = Object.assign({}, this.options);
    if (this.acceptPrice) {
      newOptions.floor = floor;
      newOptions.ceil = ceil;
    } else {
      newOptions.floor = 0;
      if (this.options.ceil && this.options.ceil < ceil) {
        newOptions.ceil = ceil;
      }
    }

    this.options = newOptions;
  }

  updateProductsPriceRange() {
    this.filter.price_from = this.minInputValue;
    this.filter.price_to = this.maxInputValue;
    this.acceptPrice = true;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        price_from: this.minInputValue,
        price_to: this.maxInputValue,
      },
      queryParamsHandling: "merge",
    });
  }

  clearPriceRang() {
    this.filter.price_from = null;
    this.filter.price_to = null;
    this.acceptPrice = false;
    this.options.floor = 0;
    this.options.ceil = 10000000;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { price_from: null, price_to: null },
      queryParamsHandling: "merge",
    });
  }

  onPriceRangChange() {
    this.minInputValue = this.minValue;
    this.maxInputValue = this.maxValue;
  }

  // onPriceInputChanges() {
  //     if (
  //         this.options.ceil &&
  //         this.maxInputValue <= this.options.ceil &&
  //         this.options.floor &&
  //         this.maxInputValue >= this.options.floor
  //     ) {
  //         this.maxValue = this.maxInputValue;
  //     } else if (
  //         this.options.ceil &&
  //         this.maxInputValue > this.options.ceil
  //     ) {
  //         this.maxInputValue = this.options.ceil;
  //     } else if (
  //         this.options.floor &&
  //         this.maxInputValue < this.options.floor
  //     ) {
  //         this.maxInputValue = this.options.floor;
  //     }

  //     if (this.options.floor && this.minInputValue >= this.options.floor) {
  //         this.minValue = this.minInputValue;
  //     } else if (
  //         this.options.floor &&
  //         this.minInputValue < this.options.floor
  //     ) {
  //         this.minInputValue = this.options.floor;
  //     }
  // }

  updateRangWithData() {
    // this.onPriceInputChanges();
    this.updateProductsPriceRange();
  }
  preventNegative(value: any) {
    return Math.abs(value);
  }


  openPDF(url: any) {
    window.open(url, '_blank');
  }

  getTitleName(data: any) {
    if (data) {
      const namesEn = data.map((item: any) => this.lang == 'en' ? item?.name_en : item?.name_ar); // Extract name_en values
      // let namesEnJoined = namesEn.join('-'); // Join name_en values with dashes
      const lastItem = namesEn.pop();
      return lastItem
    }

  }

  cretaeProductSchema(data: any) {
    for (let index = 0; index < data.length; index++) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = `
                    {
                        "@context": "https://schema.org",
                        "@type": "Product",
                        "name": "${data[index].name ? data[index]?.name : 'product name'}",
                        "description": "${data[index].name}",
                        "image": "${data[index]?.image}",
                        "offers": [
                            {
                                "@type": "Offer",
                                "priceCurrency": "${this.environmentVariables.CURRENCY_CODE_EN}",
                                "price": ${data[index].discount_price ? data[index].discount_price : data[index]?.price},
                                "seller": {
                                    "@type": "Organization",
                                    "name": "${this.environmentVariables.APP_NAME}"
                                },
                                "url": "${data[index]?.share_link}",
                                "sku": "${data[index]?.sku}",
                                "mpn": "${data[index]?.sku}"
                            }
                        ],
                        "url": "${data[index]?.share_link}",
                        "manufacturer": {
                            "@type": "Organization",
                            "name": "${data[index]?.brand ? data[index]?.brand?.name : ''}"
                        },
                        "sku": "${data[index]?.sku}",
                        "mpn": "${data[index]?.sku}"
                    }
                `;
      document.body.appendChild(script);
    }

  }

}
